import { Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface EditorHintsWrapperProps {
  children?: ReactNode;
  'data-testid'?: string;
}
export const EditorHintsWrapper = ({
  children,
  'data-testid': dataTestId = 'editor-hints-wrapper',
}: EditorHintsWrapperProps) => {
  if (!children) {
    return null;
  }

  return (
    <Flex
      top={2}
      right={4}
      position="absolute"
      zIndex={1}
      gap={2}
      alignItems="stretch"
      h={8}
      data-testid={dataTestId}
    >
      {children}
    </Flex>
  );
};
